import { AuditStatusesTable } from "@/components/settings/AuditStatusesTable";
import { GuidanceRequestTemplateSection } from "@/components/settings/GuidanceRequestTemplateSection";
import { RecipientTeamsSection } from "@/components/settings/RecipientTeamsSection";
import { PageHeader } from "@/components/shared/page-header";

export function SettingsSystemPage() {
  return (
    <div className="space-y-10">
      <section className="space-y-4">
        <PageHeader title="Audit Statuses" />
        <AuditStatusesTable />
      </section>
      <section className="space-y-4">
        <PageHeader title="Recipient Teams" />
        <RecipientTeamsSection />
      </section>
      <section className="space-y-4">
        <PageHeader title="Guidance Request Template" />
        <GuidanceRequestTemplateSection />
      </section>
    </div>
  );
}
